import React from 'react'
import PropTypes from 'prop-types'
import { Chip as MuiChip } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material'

import { util } from '../../../util'

/**
 * @param className {String} -> Overrides the default class property
 * @param disabled {Boolean} -> Enable or Disable Chip
 * @param label {String} -> The label to be displayed on the Chip
 * @returns {*}
 * @constructor
 */

const theme = createTheme({
    overrides: {
        MuiChip: {
            deleteIcon: {
                margin: '0 5px',
            },
        },
    },
})

const Chip = ({ className, disabled, label, ...rest }) => {
    const chipClass = util.joinClasses('chip', className)
    return (
        <ThemeProvider theme={theme}>
            <MuiChip disabled={disabled} className={chipClass} label={label} {...rest} />
        </ThemeProvider>
    )
}

Chip.propTypes = {
    /* disabled {Boolean} -> if true then the chip will be disabled */
    disabled: PropTypes.bool,

    /* className {String} -> overrides the default class property */
    className: PropTypes.string,

    /* label {String} -> the label to be displayed on the Chip */
    label: PropTypes.string,
}

export default Chip
